/**
 * contentHighlight.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";
import Splide from "@splidejs/splide";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.content_highlight = {
    attach: function (context, settings) {




      once('content-highlights', '.highsplide', context).forEach(
        function (element) {
          if( element.children.length > 0 ){
            var id = $(element).attr('id');
            console.log(id);
            if(typeof(id) == "undefined")
            {
              id = "splide-"+Math.floor(Math.random() * 10);
              $(element).attr('id',id);
              console.log(id);
            }

            setTimeout(() => {
              if(id != "undefined" && id != null){
                var contenthighlight = new Splide( '#'+id, {
                  type   : 'slide',
                  perPage: 3,
                  perMove: 1,
                  breakpoints: {
                    780: {
                      perPage: 2,
                    },
                    640: {
                      perPage: 1,
                    },
                  }
                } );

                contenthighlight.mount();
              }
            });
          }
        }
      );


    }
  };




})(jQuery, Drupal, drupalSettings);
